// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import { Autocomplete } from "stimulus-autocomplete"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

application.register("autocomplete", Autocomplete)

import AutocompletclickoutController from "./autocompleteclickout_controller.js"
application.register("autocompleteclickout", AutocompletclickoutController)

import TownsSuggestionsController from "./towns_suggestions_controller.js"
application.register("towns-suggestions", TownsSuggestionsController)

import Chart from 'chart.js/auto'
import annotationPlugin from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(annotationPlugin);
Chart.register(ChartDataLabels);

window.Chart = Chart;
